/**
 * Session record of location ids a shared lookbook (token link) has rendered
 * for this visitor. SitePasswordGuard lets exactly those /locations/:id pages
 * open on login-wall / site-password tenants; nothing else is unlocked.
 * sessionStorage only: closes with the tab, never shared across devices.
 */
export const SHARED_LOOKBOOK_LOCATIONS_KEY = 'shared_lookbook_locations';

export function readSharedLookbookLocationIds(): Set<string> {
  try {
    const raw = sessionStorage.getItem(SHARED_LOOKBOOK_LOCATIONS_KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return new Set(Array.isArray(arr) ? arr.map((v) => String(v)) : []);
  } catch {
    return new Set();
  }
}

export function recordSharedLookbookLocationIds(ids: Array<string | number>): void {
  try {
    const merged = readSharedLookbookLocationIds();
    for (const id of ids) {
      const s = String(id ?? '').trim();
      if (/^\d+$/.test(s)) merged.add(s);
    }
    sessionStorage.setItem(SHARED_LOOKBOOK_LOCATIONS_KEY, JSON.stringify([...merged]));
  } catch {
    // storage unavailable (private mode): the visitor simply stays gated on detail pages
  }
}
